function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator, type) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    if (type === "coin") {
      a[0].rank = parseFloat(a[0].rank);
      a[0].priceUsd = parseFloat(a[0].priceUsd);
      a[0].marketCapUsd = parseFloat(a[0].marketCapUsd);
      a[0].vwap24Hr = parseFloat(a[0].vwap24Hr);
      a[0].supply = parseFloat(a[0].supply);
      a[0].volumeUsd24Hr = parseFloat(a[0].volumeUsd24Hr);
      a[0].changePercent24Hr = parseFloat(a[0].changePercent24Hr);

      b[0].rank = parseFloat(b[0].rank);
      b[0].priceUsd = parseFloat(b[0].priceUsd);
      b[0].marketCapUsd = parseFloat(b[0].marketCapUsd);
      b[0].vwap24Hr = parseFloat(b[0].vwap24Hr);
      b[0].supply = parseFloat(b[0].supply);
      b[0].volumeUsd24Hr = parseFloat(b[0].volumeUsd24Hr);
      b[0].changePercent24Hr = parseFloat(b[0].changePercent24Hr);
    } else if (type === "coinExchange") {
      a[0].volumeUsd24Hr = parseFloat(a[0].volumeUsd24Hr);
      a[0].priceUsd = parseFloat(a[0].priceUsd);
      a[0].volumePercent = parseFloat(a[0].volumePercent);
      a[0].pair = a[0].baseSymbol + "/" + a[0].quoteSymbol;

      b[0].volumeUsd24Hr = parseFloat(b[0].volumeUsd24Hr);
      b[0].priceUsd = parseFloat(b[0].priceUsd);
      b[0].volumePercent = parseFloat(b[0].volumePercent);
      b[0].pair = b[0].baseSymbol + "/" + b[0].quoteSymbol;
    } else if (type === "exchange") {
      a[0].rank = parseFloat(a[0].rank);
      a[0].percentTotalVolume = parseFloat(a[0].percentTotalVolume);
      a[0].volumeUsd = parseFloat(a[0].volumeUsd);
      a[0].tradingPairs = parseFloat(a[0].tradingPairs);
      a[0].percentTotalVolume = parseFloat(a[0].percentTotalVolume);

      b[0].rank = parseFloat(b[0].rank);
      b[0].percentTotalVolume = parseFloat(b[0].percentTotalVolume);
      b[0].volumeUsd = parseFloat(b[0].volumeUsd);
      b[0].tradingPairs = parseFloat(b[0].tradingPairs);
      b[0].percentTotalVolume = parseFloat(b[0].percentTotalVolume);
    } else if (type === "exchangeSingleSymbole") {
      a[0].pair = a[0].baseSymbol + "/" + a[0].quoteSymbol;
      a[0].rank = parseFloat(a[0].rank);
      a[0].rate = parseFloat(a[0].priceQuote);
      a[0].priceUsd = parseFloat(a[0].priceUsd);
      a[0].volumeUsd24Hr = parseFloat(a[0].volumeUsd24Hr);
      a[0].percentExchangeVolume = parseFloat(a[0].percentExchangeVolume);
      a[0].tradesCount24Hr = parseFloat(a[0].tradesCount24Hr);

      b[0].pair = b[0].baseSymbol + "/" + b[0].quoteSymbol;
      b[0].rank = parseFloat(b[0].rank);
      b[0].rate = parseFloat(b[0].priceQuote);
      b[0].priceUsd = parseFloat(b[0].priceUsd);
      b[0].volumeUsd24Hr = parseFloat(b[0].volumeUsd24Hr);
      b[0].percentExchangeVolume = parseFloat(b[0].percentExchangeVolume);
      b[0].tradesCount24Hr = parseFloat(b[0].tradesCount24Hr);
    }

    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  //console.log("sorted data changeeeeeeee");
  return stabilizedThis.map((el) => el[0]);
}

function sort(records, order, orderBy, type) {
  return stableSort(records, getComparator(order, orderBy), type);
}

export default sort;
